import ChatScreen from "@/components/layout/chat-layout";

import { ChatProvider } from "@/context/chat-context";
import { DiagramProvider } from "@/context/diagram-context";
import { HistoryProvider, useHistory } from "@/context/history-context";
import { LibraryProvider } from "@/context/library-context";
import { UIProvider } from "@/context/ui-context";
import { REFETCH_INTERVAL } from "@/lib/constants";
import useGetDocumentService from "@/service-hooks/use-get-document-service";
import { useParams } from "react-router";

const DiagramWithHistory = ({ children }: { children: React.ReactNode }) => {
  const history = useHistory();

  return (
    <DiagramProvider onAddHistory={history.addHistory}>
      {children}
    </DiagramProvider>
  );
};

export default function Chat() {
  const { id = "" } = useParams();

  const { data: statusData } = useGetDocumentService(
    id,
    !!id,
    true,
    REFETCH_INTERVAL
  );

  return (
    <UIProvider>
      <LibraryProvider>
        <HistoryProvider>
          <DiagramWithHistory>
            <ChatProvider>
              <ChatScreen statusData={statusData?.data ?? []} />
            </ChatProvider>
          </DiagramWithHistory>
        </HistoryProvider>
      </LibraryProvider>
    </UIProvider>
  );
}
